import { withErrorBoundary } from "@sentry/nextjs";
import { gql } from "graphql-request";
import { CSSProperties, FC } from "react";
import styled from "styled-components";
import { Markdown } from "components";
import { DisclosureNoIndexContent } from "types/graphql/generated";

interface Props {
  content: DisclosureNoIndexContent;
}

const DisclosureNoIndex: FC<Props> = withErrorBoundary(({ content: { text, disclosureBackgroundColor } }) => {
  return (
    <StyledDisclosureText
      style={
        {
          "--disclosure-background-color": `${disclosureBackgroundColor}`,
        } as CSSProperties
      }
    >
      <Markdown className="Content Font_14_20_450 Color_fog40">{text}</Markdown>
    </StyledDisclosureText>
  );
}, {});

const StyledDisclosureText = styled.div`
  padding-top: 80px;
  margin-bottom: -64px;
  background: var(--disclosure-background-color);
`;

gql`
  fragment DisclosureNoIndexContent on ComponentDisclosureDisclosureNoIndex {
    disclosureBackgroundColor
    text
  }
`;

export { DisclosureNoIndex };
export type { Props as DisclosureNoIndexProps };
